import React from "react";
import ErrorContainer from "./ErrorContainer";

const Input = ({
  label,
  formRegister,
  formError,
  formKey,
  isModal = false,
  onChange,
  type = "text",
  notRequired,
  deactivate,
}) => {
  return (
    <li className={deactivate ? "deactivate-input" : ""}>
      <label className={notRequired ? "" : "required"}>{label}</label>
      <div class={`input-group`}>
        <input {...formRegister(formKey)} type={type} onChange={onChange} />
        {<ErrorContainer errors={formError} name={formKey} />}
      </div>
    </li>
  );
};

export default Input;
